import DefaultModal from './ModalDefault'
import { ModalDefaultProps } from './interface'

export { type ModalDefaultProps }

export default DefaultModal
